import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth'
import settings from './modules/settings'
import sidebar from './modules/sidebar'
import mail from './modules/mail'
import detalleUsuario from './modules/detalleUsuario'
import detalleInstitucion from './modules/detalleInstitucion'
import detallePaciente from './modules/detallePaciente'
import persona from './modules/persona'
import notificaciones from './modules/notificaciones'
import detalleObraSocial from './modules/detalleObraSocial'
import videoAyuda from './modules/videoAyuda'
import acceso from './modules/acceso'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    auth,
    settings,
    sidebar,
    mail,
    detalleUsuario,
    detallePaciente,
    detalleInstitucion,
    persona,
    notificaciones,
    detalleObraSocial,
    videoAyuda,
    acceso
  }
})
